var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"21","cy":"21","r":"21","fill":"#506BB0","key":0}),React.createElement("path",{"d":"M33 21C33 14.373 27.627 9 21 9C14.373 9 9 14.373 9 21C9 26.99 13.388 31.954 19.125 32.854V24.469H16.078V20.999H19.125V18.357C19.125 15.35 20.917 13.688 23.658 13.688C24.97 13.688 26.344 13.923 26.344 13.923V16.876H24.83C23.339 16.876 22.874 17.801 22.874 18.75V21H26.202L25.67 24.47H22.874V32.855C28.612 31.954 33 26.989 33 21Z","fill":"white","key":1})]);
}

FacebookInline.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
